<template>
    <div class="event-dropdown" @click="opened = !opened" :class="{opened: opened}" v-if="withSearch">
        <div class="event-dropdown__trigger">
            <div class="event-dropdown__ico-cont">
                <SvgIcon class="event-dropdown__shape color-burning-orange" iconName="ico-shape"/>
                <span class="event-dropdown__line"></span>
            </div>
            Choose Event
            <SvgIcon class="event-dropdown__arrow color-happy-blue" iconName="ico-chevron-down"/>
        </div>
        <ul class="event-dropdown__list">
            <Item v-for="event in events" :event="event" :key="event.name" @change="pickedEvent = $event; opened = !opened"/>
        </ul>
    </div>
    <div class="container" v-else>
        <div class="event-dropdown" @click="opened = !opened" :class="{opened: opened}">
            <div class="event-dropdown__trigger">
                <div class="event-dropdown__ico-cont">
                    <SvgIcon class="event-dropdown__shape color-burning-orange" iconName="ico-shape"/>
                    <span class="event-dropdown__line"></span>
                </div>
                Choose Event
                <SvgIcon class="event-dropdown__arrow color-happy-blue" iconName="ico-chevron-down"/>
            </div>
            <ul class="event-dropdown__list">
                <Item v-for="event in events" :event="event" :key="event.name" @change="pickedEvent = $event; opened = !opened"/>
            </ul>
        </div>
    </div>
</template>

<script>
    import SvgIcon from '../base/SvgIcon/SvgIcon.vue';
    import Item from '../parts/PartEventDopdownItem.vue';
	import axios from 'axios';
    export default {
        components: {
            SvgIcon,
            Item
        },
        props: {
            withSearch: Boolean,
			type: String
        },
		created() {
			this.getEvents();
		},
		methods: {
			getEvents: function() {
				axios.post('/wp-json/fws/v1/get-categories', {type: this.type})
					.then(response => {
						// this.events = response.data;
						this.events = response.data;
					})
					.catch(error => console.log(error));
			},
		},
        data() {
            return {
                opened: false,
                pickedEvent: '',
                events: []
            };
        }
    };
</script>

<style lang="scss" scoped>
    .event-dropdown {
        position: relative;
        background-color: $cello;
        color: $white;
        text-transform: uppercase;
        width: 270px;
        border-radius: 10px;
        cursor: pointer;
		z-index: 5;
        &::before {
            content: '';
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            pointer-events: none;
            opacity: 0;
            cursor: default;
        }
        &.opened {
             &::before {
                pointer-events: all;
            }
            .event-dropdown__list {
                pointer-events: all;
                opacity: 1;
            }
            .event-dropdown__line {
                &::before,
                &::after {
                    transform: translateY(0);
                }
            }
        }
        @include mq($md) {
            width: 100%;
        }
    }

    .event-dropdown__trigger {
        display: inline-flex;
        width: 100%;
        height: 80px;
        align-items: center;
        padding-left: 17px;
        padding-right: 19px;
        font-size: 15px;
        font-weight: 500;
        letter-spacing: 1.25px;
    }

    .event-dropdown__ico-cont {
        display: inline-block;
        position: relative;
        width: 50px;
        height: 50px;
        margin-right: 20px;
    }

    .event-dropdown__line {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 19px;
        height: 2px;
        background-color: $white;
        &::before,
        &::after {
            content: '';
            position: absolute;
            width: 100%;
            height: 100%;
            background-color: inherit;
            left: 0;
            bottom: 0;
            transition: transform $dur $ease;
        }
        &::before {
            transform: translateY(-6px);
        }
        &::after {
            transform: translateY(6px);
        }
    }

    .event-dropdown__shape {
        font-size: 50px;
        height: 50px;
    }

    .event-dropdown__arrow {
        font-size: 22px;
        height: 22px;
        margin-left: auto;
    }

    .event-dropdown__list {
        position: absolute;
        z-index: 5;
        top: calc(100% - 10px);
        left: 0;
        width: 100%;
        background-color: $cello;
        border-radius: 0 0 10px 10px;
        padding: 29px 0 46px;
        pointer-events: none;
        opacity: 0;
        transition: $dur $ease;
        @include mq($md) {
            display: flex;
            flex-wrap: wrap;
            padding-bottom: 0;
        }
    }
</style>
